import React, { useState, useEffect } from "react";
import Footer from "./Footer.js";
import Headerpage from "./Header2.js";
import { getData } from "../../../Services/Fetchnodeservices.js";

const PressRelease = () => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get server URL from environment or config
  const serverURL = process.env.REACT_APP_SERVER_URL || "http://localhost:5000";

  // Static videos data (remains as is)
  const videos = [
    {
      platform: "Facebook",
      title: "Zaptodoor Featured Video Update",
      desc: "Official Facebook video highlight about the latest Zaptodoor update.",
      src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F943643491569902%2F&show_text=true&width=267&t=0",
      height: "591",
    },
    {
      platform: "Instagram",
      title: "Instagram Reel: Service Highlights",
      desc: "Quick reel showcasing service quality and delivery workflow.",
      src: "https://www.instagram.com/reel/DVOHEbGkX40/embed/captioned",
      height: "591",
    },
    {
      platform: "Facebook",
      title: "Facebook Reel: Team & Operations",
      desc: "Facebook reel featuring team operations highlights.",
      src: "https://www.facebook.com/plugins/video.php?height=448&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F4229225380659044%2F&show_text=true&width=560&t=0",
      height: "563",
    },
  ];

  // Function to get full image URL
  const getImageUrl = (pic) => {
    if (!pic) return "https://via.placeholder.com/300x300?text=No+Image";
    return `${serverURL}/uploadnew/upload/${pic}`;
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "Date not available";
    try {
      // Handle different date formats (rd: "2025/4/12")
      let date;
      if (dateString.includes('/')) {
        const parts = dateString.split('/');
        date = new Date(parts[0], parts[1] - 1, parts[2]);
      } else {
        date = new Date(dateString);
      }
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch (error) {
      return dateString;
    }
  };

  // Format description - handle \r\n and line breaks
  const formatDescription = (description) => {
    if (!description) return [];
    // Split by \r\n, \n, or . followed by space for better paragraph detection
    let paragraphs = description.split(/\r\n|\n/);
    // Filter out empty paragraphs
    paragraphs = paragraphs.filter(p => p.trim().length > 0);
    return paragraphs;
  };

  // Truncate description for card preview
  const truncateDescription = (description, maxLength = 120) => {
    if (!description) return "";
    const cleanText = description.replace(/\r\n|\n/g, ' ');
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + "...";
  };

  // Fetch articles from API
  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const response = await getData("pressrelase/fetch_all_press_release");
        
        if (response && response.data) {
          setArticles(response.data);
        } else if (Array.isArray(response)) {
          setArticles(response);
        } else {
          setArticles([]);
        }
      } catch (err) {
        console.error("Error fetching articles:", err);
        setError("Failed to load articles. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  // Close modal on escape key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setSelectedArticle(null);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Poppins', sans-serif",
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        minHeight: "100vh",
      }}
    >
      <Headerpage />
      
      {/* HERO SECTION */}
      <section
        style={{
          position: "relative",
          height: "400px",
          background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #5b21b6 100%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "400px",
            height: "400px",
            background: "rgba(139, 92, 246, 0.1)",
            borderRadius: "50%",
            top: "-200px",
            left: "-150px",
            animation: "float 6s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "350px",
            height: "350px",
            background: "rgba(139, 92, 246, 0.1)",
            borderRadius: "50%",
            bottom: "-180px",
            right: "-120px",
            animation: "float 8s ease-in-out infinite reverse",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "200px",
            height: "200px",
            background: "rgba(255,255,255,0.03)",
            borderRadius: "50%",
            top: "20%",
            right: "15%",
            animation: "pulse 4s ease-in-out infinite",
          }}
        />
        
        <style>
          {`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes pulse {
              0%, 100% { transform: scale(1); opacity: 0.3; }
              50% { transform: scale(1.1); opacity: 0.5; }
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes modalSlideIn {
              from {
                opacity: 0;
                transform: scale(0.95) translateY(20px);
              }
              to {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
            }
            @keyframes modalBackdrop {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            .card-hover {
              transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            }
            .card-hover:hover {
              transform: translateY(-12px) scale(1.02);
            }
            .modal-content {
              animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.2, 0.64, 1);
            }
            .modal-backdrop {
              animation: modalBackdrop 0.3s ease;
            }
          `}
        </style>
        
        <h1
          style={{
            fontSize: "64px",
            fontWeight: "800",
            marginBottom: "20px",
            zIndex: 2,
            background: "linear-gradient(135deg, #fff 0%, #c4b5fd 50%, #a78bfa 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            animation: "fadeIn 0.8s ease-out",
          }}
        >
          Press Release
        </h1>
        <p
          style={{
            fontSize: "20px",
            opacity: 0.95,
            zIndex: 2,
            maxWidth: "650px",
            lineHeight: "1.6",
            animation: "fadeIn 1s ease-out 0.2s both",
          }}
        >
          Latest news, media coverage, and highlights from Zaptodoor
        </p>
      </section>

      {/* MAIN SECTION */}
      <section style={{ padding: "80px 24px" }}>
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          
          {/* VIDEO SECTION */}
          <div style={{ marginBottom: "120px" }}>
            <div style={{ textAlign: "center", marginBottom: "70px" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "8px 20px",
                  background: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                  color: "#5b21b6",
                  borderRadius: "50px",
                  fontSize: "14px",
                  fontWeight: "700",
                  marginBottom: "20px",
                  letterSpacing: "1px",
                }}
              >
                Media Coverage
              </span>
              <h2
                style={{
                  fontSize: "56px",
                  fontWeight: "800",
                  color: "#0f172a",
                  marginBottom: "20px",
                }}
              >
                Press <span style={{ 
                  background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}>Videos</span>
              </h2>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  background: "linear-gradient(90deg, #7c3aed, #c084fc, #7c3aed)",
                  margin: "0 auto",
                  borderRadius: "2px",
                }}
              />
              <p style={{ color: "#64748b", fontSize: "18px", marginTop: "24px" }}>
                Watch our featured media coverage
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
                gap: "40px",
              }}
            >
              {videos.map((video, index) => (
                <div
                  key={index}
                  className="card-hover"
                  style={{
                    background: "#fff",
                    borderRadius: "28px",
                    overflow: "hidden",
                    boxShadow: "0 20px 40px -12px rgba(0,0,0,0.1)",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        position: "absolute",
                        top: "20px",
                        left: "20px",
                        zIndex: 1,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "8px 18px",
                          borderRadius: "30px",
                          background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                          color: "#fff",
                          fontSize: "13px",
                          fontWeight: "700",
                          backdropFilter: "blur(10px)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        {video.platform}
                      </span>
                    </div>
                    <iframe
                      src={video.src}
                      width="100%"
                      height={video.height}
                      scrolling="no"
                      style={{
                        border: "none",
                        display: "block",
                      }}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                      allowFullScreen
                      loading="lazy"
                      title={video.title}
                    />
                  </div>
                  <div style={{ padding: "32px" }}>
                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        marginBottom: "14px",
                        color: "#0f172a",
                        lineHeight: "1.4",
                      }}
                    >
                      {video.title}
                    </h3>
                    <p
                      style={{
                        color: "#64748b",
                        lineHeight: "1.7",
                        fontSize: "15px",
                        margin: 0,
                      }}
                    >
                      {video.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ARTICLES SECTION */}
          <div>
            <div style={{ textAlign: "center", marginBottom: "70px" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "8px 20px",
                  background: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                  color: "#5b21b6",
                  borderRadius: "50px",
                  fontSize: "14px",
                  fontWeight: "700",
                  marginBottom: "20px",
                  letterSpacing: "1px",
                }}
              >
                Latest News
              </span>
              <h2
                style={{
                  fontSize: "56px",
                  fontWeight: "800",
                  color: "#0f172a",
                  marginBottom: "20px",
                }}
              >
                Press <span style={{ 
                  background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}>Articles</span>
              </h2>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  background: "linear-gradient(90deg, #7c3aed, #c084fc, #7c3aed)",
                  margin: "0 auto",
                  borderRadius: "2px",
                }}
              />
              <p style={{ color: "#64748b", fontSize: "18px", marginTop: "24px" }}>
                Read about our journey and achievements
              </p>
            </div>

            {/* Loading State */}
            {loading && (
              <div style={{ textAlign: "center", padding: "80px 20px" }}>
                <div
                  style={{
                    display: "inline-block",
                    width: "70px",
                    height: "70px",
                    border: "4px solid #e2e8f0",
                    borderTop: "4px solid #7c3aed",
                    borderRight: "4px solid #a78bfa",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <p style={{ marginTop: "28px", color: "#64748b", fontSize: "16px", fontWeight: "500" }}>
                  Loading amazing articles...
                </p>
              </div>
            )}

            {/* Error State */}
            {error && !loading && (
              <div
                style={{
                  textAlign: "center",
                  padding: "70px",
                  background: "linear-gradient(135deg, #fef2f2, #fee2e2)",
                  borderRadius: "28px",
                  color: "#dc2626",
                }}
              >
                <div style={{ fontSize: "56px", marginBottom: "20px" }}>⚠️</div>
                <p style={{ fontSize: "18px", marginBottom: "28px", fontWeight: "500" }}>{error}</p>
                <button
                  onClick={() => window.location.reload()}
                  style={{
                    padding: "14px 32px",
                    background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50px",
                    cursor: "pointer",
                    fontSize: "15px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(124, 58, 237, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(124, 58, 237, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 12px rgba(124, 58, 237, 0.3)";
                  }}
                >
                  Try Again
                </button>
              </div>
            )}

            {/* Articles Grid */}
            {!loading && !error && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
                  gap: "40px",
                }}
              >
                {articles.length > 0 ? (
                  articles.map((article, index) => (
                    <div
                      key={article.id || index}
                      onClick={() => setSelectedArticle(article)}
                      className="card-hover"
                      style={{
                        background: "#fff",
                        borderRadius: "28px",
                        overflow: "hidden",
                        cursor: "pointer",
                        boxShadow: "0 20px 40px -12px rgba(0,0,0,0.08)",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        position: "relative",
                      }}
                    >
                      <div style={{ position: "relative", overflow: "hidden" }}>
                        <img
                          src={getImageUrl(article.pic)}
                          alt={article.title || "Press article"}
                          style={{
                            width: "100%",
                            height: "280px",
                            objectFit: "cover",
                            transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.transform = "scale(1.08)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "scale(1)";
                          }}
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/400x280?text=No+Image";
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "100px",
                            background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "20px",
                            right: "20px",
                            background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                            color: "#fff",
                            padding: "8px 14px",
                            borderRadius: "25px",
                            fontSize: "12px",
                            fontWeight: "700",
                            backdropFilter: "blur(10px)",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          }}
                        >
                          {formatDate(article.rd || article.date || article.publish_date)}
                        </div>
                      </div>
                      
                      <div style={{ padding: "32px" }}>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "20px",
                            padding: "6px 16px",
                            background: "#f3e8ff",
                            borderRadius: "30px",
                          }}
                        >
                          <div
                            style={{
                              width: "8px",
                              height: "8px",
                              background: "#7c3aed",
                              borderRadius: "50%",
                              animation: "pulse 2s ease-in-out infinite",
                            }}
                          />
                          <span
                            style={{
                              color: "#7c3aed",
                              fontSize: "12px",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              letterSpacing: "1px",
                            }}
                          >
                            Press Release
                          </span>
                        </div>
                        
                        <h3
                          style={{
                            fontSize: "24px",
                            fontWeight: "700",
                            lineHeight: "1.4",
                            color: "#0f172a",
                            marginBottom: "16px",
                            transition: "color 0.3s ease",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = "#7c3aed";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = "#0f172a";
                          }}
                        >
                          {article.title || "Untitled"}
                        </h3>
                        
                        {article.description && (
                          <p
                            style={{
                              color: "#64748b",
                              fontSize: "14px",
                              lineHeight: "1.6",
                              marginBottom: "20px",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {truncateDescription(article.description, 100)}
                          </p>
                        )}
                        
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            color: "#7c3aed",
                            fontSize: "15px",
                            fontWeight: "600",
                            marginTop: "24px",
                            paddingTop: "20px",
                            borderTop: "2px solid #f1f5f9",
                          }}
                        >
                          <span>Read Full Article</span>
                          <span 
                            style={{ 
                              transition: "transform 0.3s ease",
                              fontSize: "18px",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = "translateX(8px)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = "translateX(0)";
                            }}
                          >
                            →
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "80px 40px",
                      gridColumn: "1/-1",
                      background: "linear-gradient(135deg, #fff, #f8fafc)",
                      borderRadius: "28px",
                      boxShadow: "0 20px 40px -12px rgba(0,0,0,0.08)",
                    }}
                  >
                    <div style={{ fontSize: "72px", marginBottom: "20px" }}>📰</div>
                    <p style={{ color: "#64748b", fontSize: "20px", fontWeight: "500" }}>
                      No articles found
                    </p>
                    <p style={{ color: "#94a3b8", fontSize: "14px", marginTop: "8px" }}>
                      Check back later for updates
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* IMPROVED MODAL WITH PROPER DESCRIPTION FORMATTING */}
      {selectedArticle && (
        <div
          onClick={() => setSelectedArticle(null)}
          className="modal-backdrop"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(12px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            zIndex: 9999,
            cursor: "pointer",
            overflow: "auto",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="modal-content"
            style={{
              background: "#fff",
              borderRadius: "40px",
              maxWidth: "1000px",
              width: "100%",
              maxHeight: "90vh",
              overflow: "auto",
              position: "relative",
              cursor: "default",
              boxShadow: "0 40px 80px -20px rgba(0,0,0,0.5)",
            }}
          >
            {/* Custom Scrollbar Styles */}
            <style>
              {`
                .modal-content::-webkit-scrollbar {
                  width: 8px;
                }
                .modal-content::-webkit-scrollbar-track {
                  background: #f1f5f9;
                  border-radius: 10px;
                }
                .modal-content::-webkit-scrollbar-thumb {
                  background: linear-gradient(135deg, #7c3aed, #a78bfa);
                  border-radius: 10px;
                }
                .modal-content::-webkit-scrollbar-thumb:hover {
                  background: #5b21b6;
                }
              `}
            </style>

            {/* Hero Image Section with Overlay */}
            <div style={{ position: "relative" }}>
              <img
                src={getImageUrl(selectedArticle.pic)}
                alt={selectedArticle.title || "Press article"}
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "cover",
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                }}
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/1000x400?text=No+Image";
                }}
              />
              {/* Gradient Overlay */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "150px",
                  background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                }}
              />
              
              {/* Close Button */}
              <button
                onClick={() => setSelectedArticle(null)}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  border: "none",
                  background: "rgba(255,255,255,0.95)",
                  color: "#0f172a",
                  fontSize: "24px",
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  backdropFilter: "blur(8px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #7c3aed, #a78bfa)";
                  e.target.style.color = "#fff";
                  e.target.style.transform = "scale(1.1) rotate(90deg)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.95)";
                  e.target.style.color = "#0f172a";
                  e.target.style.transform = "scale(1) rotate(0deg)";
                }}
              >
                ×
              </button>

              {/* Date Badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: "30px",
                  left: "30px",
                  background: "linear-gradient(135deg, #7c3aed, #a78bfa)",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "700",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  zIndex: 5,
                }}
              >
                📅 {formatDate(selectedArticle.rd || selectedArticle.date || selectedArticle.publish_date)}
              </div>
            </div>

            {/* Content Section */}
            <div style={{ padding: "48px" }}>
              {/* Category Tag */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "24px",
                  padding: "8px 20px",
                  background: "linear-gradient(135deg, #f3e8ff, #ede9fe)",
                  borderRadius: "40px",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    background: "#7c3aed",
                    borderRadius: "50%",
                    animation: "pulse 2s ease-in-out infinite",
                  }}
                />
                <span
                  style={{
                    color: "#5b21b6",
                    fontSize: "13px",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    letterSpacing: "2px",
                  }}
                >
                  Press Release
                </span>
              </div>

              {/* Title */}
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  lineHeight: "1.3",
                  color: "#0f172a",
                  marginBottom: "28px",
                  letterSpacing: "-0.02em",
                }}
              >
                {selectedArticle.title || "Untitled"}
              </h2>

              {/* Share Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "32px",
                  paddingBottom: "24px",
                  borderBottom: "2px solid #f1f5f9",
                  flexWrap: "wrap",
                }}
              >
                <span style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>
                  Share this article:
                </span>
                <button
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: selectedArticle.title,
                        text: selectedArticle.description,
                        url: window.location.href,
                      });
                    } else {
                      navigator.clipboard.writeText(window.location.href);
                      alert("Link copied to clipboard!");
                    }
                  }}
                  style={{
                    padding: "8px 16px",
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "30px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#475569",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#7c3aed";
                    e.target.style.color = "#fff";
                    e.target.style.borderColor = "#7c3aed";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#f8fafc";
                    e.target.style.color = "#475569";
                    e.target.style.borderColor = "#e2e8f0";
                  }}
                >
                  📤 Share
                </button>
              </div>

              {/* Description - Properly formatted with paragraphs */}
              {selectedArticle.description && (
                <div
                  style={{
                    color: "#334155",
                    lineHeight: "1.9",
                    fontSize: "17px",
                  }}
                >
                  {formatDescription(selectedArticle.description).map((paragraph, idx) => (
                    <p key={idx} style={{ marginBottom: "24px", textAlign: "justify" }}>
                      {paragraph.trim()}
                    </p>
                  ))}
                </div>
              )}

              {/* Footer Note */}
              <div
                style={{
                  marginTop: "48px",
                  paddingTop: "24px",
                  borderTop: "2px solid #f1f5f9",
                  textAlign: "center",
                  color: "#94a3b8",
                  fontSize: "13px",
                }}
              >
                <span>© 2024 Zaptodoor • All Rights Reserved</span>
              </div>
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default PressRelease;